'use client';
import { motion } from 'framer-motion';
import { useEffect, useState } from 'react';
import Image from 'next/image';
import 'react-lazy-load-image-component/src/effects/blur.css';
import classes from './Carousel.module.css';
import { ChevronDown, ChevronUp } from 'react-feather';

const ImagesPreview = ({ listing }) => {
	const [previewSet, setPreviewSet] = useState([]);
	const [currentpage, setCurrentpage] = useState(0);

	const [current, setCurrent] = useState(0);

	useEffect(() => {
		const imageElement = document.getElementById('carousel-image');

		if (!imageElement) return;

		// Create a MutationObserver to listen for changes to the `src` attribute
		const observer = new MutationObserver((mutationsList) => {
			for (const mutation of mutationsList) {
				if (mutation.attributeName === 'currentindex') {
					const currentVal = imageElement.getAttribute('currentindex');

					setCurrent(currentVal ? Number(currentVal) : 0);
				}
			}
		});

		// Start observing changes to the `src` attribute
		observer.observe(imageElement, { attributes: true });

		// Cleanup observer when component unmounts
		return () => observer.disconnect();
	}, []);

	useEffect(() => {
		const imageElement = document.getElementById('carousel-image');

		if (!imageElement) return;

		// Create a MutationObserver to listen for changes to the `src` attribute
		const observer = new MutationObserver((mutationsList) => {
			for (const mutation of mutationsList) {
				if (mutation.attributeName === 'currentpage') {
					const currentVal = imageElement.getAttribute('currentpage');
					setCurrentpage(currentVal ? Number(currentVal) : 0);
				}
			}
		});

		// Start observing changes to the `src` attribute
		observer.observe(imageElement, { attributes: true });

		// Cleanup observer when component unmounts
		return () => observer.disconnect();
	}, []);

	const [idx, setIdx] = useState(0);
	const [currentImg, setCurrentImg] = useState();

	useEffect(() => {
		let preview = [];
		let i = 0;
		if (currentpage === 0) {
			preview = listing.images.slice(0, 6);
			i = 0;
		} else if (currentpage === 1) {
			preview = listing.images.slice(6, 12);
			i = 6;
		} else if (currentpage === 2) {
			preview = listing.images.slice(12, 18);
			i = 12;
		} else if (currentpage === 3) {
			preview = listing.images.slice(18, 24);
			i = 18;
		}
		setIdx(i);
		setPreviewSet(preview);
	}, [currentpage, listing]);

	const handleClick = (index) => {
		setCurrent(index + idx);
		const imageElement = document?.getElementById('carousel-image');
		if (imageElement) {
			imageElement.src = `${
				listing.images[index + idx]
			}?tr=w-876,h-1134,c-at_max_enlarge`;

			imageElement.currentindex = index + idx;
			imageElement.setAttribute('currentindex', index + idx);
		}
	};

	useEffect(() => {
		setCurrentImg(listing.images[current]);
		const imageElement = document?.getElementById('carousel-image');
		if (imageElement) {
			imageElement.src = `${listing.images[current]}?tr=w-876,h-1134,c-at_max_enlarge`;
			imageElement.setAttribute('currentindex', current);
		}
	}, [current]);

	const nextPage = () => {
		setCurrentpage(currentpage + 1);
		const imageElement = document?.getElementById('carousel-image');
		if (imageElement) {
			imageElement.setAttribute('currentpage', currentpage + 1);
		}
	};

	const previousPage = () => {
		setCurrentpage(currentpage - 1);
		const imageElement = document?.getElementById('carousel-image');
		if (imageElement) {
			imageElement.setAttribute('currentpage', currentpage - 1);
		}
	};

	return (
		<>
			<motion.div
				key={currentpage}
				initial={{ opacity: 0, y: '100px' }}
				animate={{ opacity: 1, y: 0 }}
				transition={{
					duration: 0.8,
					type: 'spring',
					stiffness: 400,
					damping: 40,
				}}
				className={classes.wrapper}
			>
				<div className={classes.wrapperContainer}>
					{currentpage !== 0 && (
						<div className={classes.scroll} onClick={() => previousPage()}>
							<ChevronUp className={classes.arrow} />
						</div>
					)}
				</div>

				<ul className={classes.imagePreview}>
					{previewSet?.map((image, idx) => (
						<li key={idx}>
							<Image
								className={
									currentImg === image ? classes.image : classes.nonActive
								}
								src={
									image?.includes('imagekit.io')
										? `${image}?tr=w-80,h-80,q-75`
										: image
								}
								effect="blur"
								alt={`${listing.title} - image ${idx}`}
								width={80}
								height={80}
								onMouseEnter={() => handleClick(idx)}
							/>
						</li>
					))}
				</ul>
				<div className={classes.wrapperContainer}>
					{previewSet.length >= 6 && listing.images.length > 6 && (
						<button className={classes.scroll} onClick={() => nextPage()}>
							<ChevronDown className={classes.arrow} />
						</button>
					)}
				</div>
			</motion.div>
		</>
	);
};

export default ImagesPreview;
